<template>
  <v-container fluid class="white elevation-4 pt-0">
    <main-app-bar :title="$router.currentRoute.meta.title">
    </main-app-bar>
    <v-container fluid v-if="!loadingReportError">
    <v-flex class="d-flex justify-end text-center">
        <v-btn rounded color="primary" :to="{name: 'budget'}">
            <v-icon>$settingsIcon</v-icon>
        </v-btn>
    </v-flex>
    <v-row>
<!--        <v-expansion-panels class="pt-5 pb-5">-->
<!--            <v-expansion-panel-->
<!--                v-for="item in groups"-->
<!--                :key="item.id"-->
<!--            >-->
<!--                <v-expansion-panel-header>{{item.title}}</v-expansion-panel-header>-->
<!--                <v-expansion-panel-content>-->
<!--                    <v-flex class="d-flex align-center">-->
<!--                        <v-btn-toggle-->
<!--                            v-model="selectedClinics"-->
<!--                            multiple-->
<!--                            class="buttonToggleContainer"-->
<!--                            :style="item.clinics.length > 4 ? 'padding-left:120px;' : null"-->
<!--                        >-->
<!--                            <v-btn :value="clinic.id" v-for="clinic in item.clinics" :key="clinic.id" class="primary lighten-1" rounded @click="clinicSelected(clinic.id)">-->
<!--                                {{ clinic.title }}-->
<!--                            </v-btn>-->
<!--                        </v-btn-toggle>-->
<!--                    </v-flex>-->
<!--                </v-expansion-panel-content>-->
<!--            </v-expansion-panel>-->
<!--        </v-expansion-panels>-->
            <v-col
                cols="12"
                v-for="item in groups"
                :key="item.id"
            >
                <h3>{{item.title}}</h3>
                    <v-flex class="btn-scroll d-flex align-center mt-5">
                        <v-btn-toggle
                            v-model="selectedClinics"
                            multiple
                        >
                            <v-btn :value="clinic.id" v-for="clinic in item.clinics" :key="clinic.id" class="primary lighten-1" rounded @click="clinicSelected(clinic.id)">
                                {{ clinic.title }}
                            </v-btn>
                        </v-btn-toggle>
                    </v-flex>
            </v-col>
    </v-row>
      <v-row class="fill-height px-4 pt-5">
        <v-col cols="12" class="pt-0">
          <v-flex class="text-left" v-if="selectedYear && timePeriod === 'MONTH' && !loading">
            <v-btn class="" @click="showYearsTable()">Back to years</v-btn>
          </v-flex>
          <v-flex class="text-center">
            <v-progress-circular
              indeterminate
              color="green"
              v-if="loading"
            ></v-progress-circular>
          </v-flex>
          <v-data-table
            :hide-default-header="true"
            :hide-default-footer="true"
            item-key="name"
            show-expand
            dense
            class="elevation-0 table-bordered"
            no-data-text="Please select clinics"
          >
            <template v-slot:header>
              <thead>
                <tr>
                  <th rowspan="2" class="text-center font-weight-bold body-2">
                  </th>
                  <th v-for="day in periods" :key="day.id">
                    <div class="text-center body-2 text-uppercase font-weight-bold custom-years-title" :class="isClosedPeriod(day)" style="cursor: pointer;" @click="timePeriodHandle(day.id)"> {{day.name}} </div>
                  </th>
                </tr>
              </thead>
            </template>
            <template v-slot:body>
              <tbody>
                <template v-for="(report, index) in reports">
                  <tr :key="index">
                    <td style="position: relative; border: none !important;">
                      <div class="d-flex align-center justify-space-between">
                        <span class="text-uppercase" style="font-weight: bold; font-size: 24px">{{report.name || 'Profits'}}</span>
                      </div>
                    </td>
                  </tr>
                  <template v-for="(category, index) in report.categories">
                    <tr :key="category.name + index" class="expandable-tr" :class="{'expanded' : !category.isExpand}" @click="expandHandler(category)">
                      <td style="position: relative">
                        <div class="d-flex align-center justify-space-between">
                          <span class="text-uppercase">{{category.name}}</span>
                          <v-btn
                            :color="category.isExpand ? '#6c9d39' : ''"
                            fab icon x-small elevation="0">
                              <v-icon
                                :style="category.isExpand ? 'transform: rotateZ(180deg)' : ''"
                                large>
                                  mdi-chevron-down
                              </v-icon>
                            </v-btn>
                        </div>
                      </td>
                      <td v-for="(day) in category.periodReports" :key="'td' + day.id">
                          <div class="text-center">
                            <span :style="day.isOverbudget ? 'color: red' : null">{{specialNumberOutput(day.value)}}</span>
                            <br/>
                            <span v-if="day.overbudgetValue" class="overbudget-value">({{+day.overbudgetValue.toFixed(2)}})</span>
                          </div>
                      </td>
                    </tr>
                    <template v-for="clinicReport in category.clinicReports">
                      <tr :key="'expand' + clinicReport.id + index + Math.floor(Math.random() * Math.floor(1000))" v-if="category.isExpand" class="expanded-content">
                        <td>
                          {{clinicReport.name}}
                        </td>
                        <td v-for="(day) in clinicReport.periodReports" :key="'td' + day.id">
                          <div class="text-center">
                            <span :style="day.isOverbudget ? 'color: red' : null">{{specialNumberOutput(day.value)}}</span>
                            <br/>
                            <span v-if="day.overbudgetValue" class="overbudget-value">({{+day.overbudgetValue.toFixed(2)}})</span>
                          </div>
                        </td>
                      </tr>
                    </template>
                  </template>
                </template>
              </tbody>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="text-center" v-else>
      <h1>Something wrong with your Xero access</h1>
        <v-btn
            class="mt-5"
            :href="xeroLoginHref"
        >Login</v-btn>
    </v-container>
  </v-container>
</template>

<script>
import MainAppBar from '@/components/MainAppBar'
import config from '@/common/config'

export default {
    components: {
      MainAppBar
    },
    data: () => ({
      selectedClinics: [],
      clinicStatuses: {},
      clinicsReports: [],
      loadingReportError: false,
      timePeriod: 'YEAR',
      selectedYear: null,
      loading: false,
      groups: [],
      reportData: [],
      periods: null,
      currentMonth: new Date().getMonth() + 1
    }),
    computed: {
        reports () {
          const reports = this.reportData
          if (reports) {
            return reports.map(clinic => {
              const clinicStatus = this.clinicStatuses[clinic.id]
              if (clinicStatus) {
                clinic.isExpand = clinicStatus.isExpand
              } else {
                clinic.isExpand = false
              }
              return clinic
            })
          }
          return reports
      },
      xeroLoginHref () {
        return config.apiUrl + 'xero/login'
      }
    },
    methods: {
      expandHandler: function (item) {
        item.isExpand = !item.isExpand
        this.$set(this.clinicStatuses, undefined, {
          isExpand: true
        })
      },
      specialNumberOutput (item) {
        const withCommas = this.numberWithCommas(item)
        if (Math.sign(parseInt(withCommas)) === -1) {
            return `(${withCommas.toString().slice(1)})`
        }
        return withCommas
      },
      numberWithCommas (x) {
          return x
          // const parts = x.toString().split('.')
          // return parts.join()
      },
      clinicSelected (clinicId) {
        if (this.clinicsReports.find(item => item === clinicId)) {
          this.clinicsReports.forEach((item, index) => {
            if (item === clinicId) { this.clinicsReports.splice(index, 1) }
          })
        } else {
          this.clinicsReports.push(clinicId)
        }
        this.getAccountingTableData()
      },
      async getAccountingTableData () {
        const params = {
          year: this.selectedYear,
          period: this.timePeriod,
          clinics: this.clinicsReports
        }
        this.loading = true
        await this.$store.dispatch('fetchAccountingReport', params).then(({ data }) => {
          const report = data.report
          this.periods = data.periods
          if (this.timePeriod === 'MONTH') {
            const idOfLastMonthPrevYear = this.periods.reduce((prev, curr, index) => {
            return curr.id > prev.id ? index : prev
            })
            let monthsPrevYear = []
            monthsPrevYear = this.periods.splice(idOfLastMonthPrevYear)
            this.periods.forEach(month => {
                month.year = this.selectedYear
            })
            monthsPrevYear.forEach(month => {
                month.year = this.selectedYear - 1
            })
            this.periods.push(...monthsPrevYear)
          }
          if (report.length > 0) {
            const emptyElement = (item) => item.name === ''
            const index = report.findIndex(emptyElement)
            report.splice(1, 0, report.splice(index, 1)[0])
          }
          this.reportData = report
        }).catch(error => {
          console.error(error)
        }).finally(() => {
          this.loading = false
        })
      },
      timePeriodHandle (period) {
        if (String(period).length > 2) {
          this.timePeriod = 'MONTH'
          this.selectedYear = period
          this.getAccountingTableData()
        }
      },
      showYearsTable () {
        this.timePeriod = 'YEAR'
        this.selectedYear = null
        this.getAccountingTableData()
      },
      isClosedPeriod (month) {
        const currentYear = new Date().getFullYear()
        if (this.timePeriod === 'MONTH' && !this.loading) {
          if (
            (this.currentMonth === month.id && currentYear === month.year) ||
            (month.id === 12 && this.currentMonth === 1 && currentYear - 1 === month.year) ||
            (this.currentMonth - 1 === month.id && currentYear === month.year) ||
            (this.currentMonth - 2 === month.id && currentYear === month.year) ||
            (this.currentMonth === 1 && month.id === 11 && currentYear - 1 === month.year) ||
            (this.currentMonth === 2 && month.id === 12 && currentYear - 1 === month.year)
            ) {
            return 'noClosed-months'
          } else if (this.currentMonth < month.id && currentYear === month.year) {
            return 'futureMonths'
          } else if ((this.currentMonth > month.id && currentYear === month.year) || currentYear > month.year) {
            return 'closed'
          }
        }
      }
    },
    async mounted () {
      await this.$store.dispatch('fetchAccountingGroups').then(({ data }) => {
        this.groups = data.clinicGroups
        this.selectedClinics.push(data.clinicGroups[0].clinics[0].id)
        this.clinicSelected(data.clinicGroups[0].clinics[0].id)
      }).catch(error => {
        console.error(error)
        this.loadingReportError = true
      })
    }
}
</script>
<style lang="scss" scoped>
  .btn-scroll {
    overflow-x: auto;
  }
  .table-bordered {
    table {
      border-collapse: collapse !important;
      td {
        height: 50px;
        border-collapse: collapse;
        padding-left: 0px;
        padding-right: 0px;
        border-left: thin solid rgba(0, 0, 0, .12) !important;
        &:first-child {
          width: 350px;
          padding: 0 10px;
        }
        &:last-child {
          border-right: thin solid rgba(0, 0, 0, .12) !important;
        }
      }
      tr {
        border-left: 0;
        &:hover {
          background-color: lighten(#ececec, 10%) !important;
        }
        &.expanded-content {
          background-color: #f8f8f8;
        }
        &.expandable-tr {
          cursor: pointer;
          background-color: #fff;
          font-weight: bold;
          &:hover {
            background-color: darken(#F3F7EF, 5%) !important;
          }
          &.disabled-tr {
            opacity: 0.5;
          }
          &.expanded {
            background-color: #F3F7EF;
            color: #6c9d39;
          }
          td {
            border-top: 1px solid #7d7c7c !important;
          }
        }
      }
      thead {
        th {
          border-left: 0;
          padding-left: 10px;
          padding-right: 10px;
          color: #000;
        }
        tr {
          transition: all .3s;
          th {
            height: 20px;
            padding-top: 0;
            padding-bottom: 0;
          }
          &:first-child {
            th {
              padding: 5px !important;
              height: 20px;
            }
          }
          &:last-child {
            th {
              border-bottom: 0;
            }
          }
        }
      }
    }
  }
  .shake-animation {
    animation: shake 1s linear;
  }
  .overbudget-value {
    display: inline-block;
    margin-left: 5px;
    color: #808080;
  }
  @keyframes shake {
    0%, 100% {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }

    10%, 30%, 50%, 70%, 90% {
      -webkit-transform: translate3d(-10px, 0, 0);
      transform: translate3d(-10px, 0, 0);
    }

    20%, 40%, 60%, 80% {
      -webkit-transform: translate3d(10px, 0, 0);
      transform: translate3d(10px, 0, 0);
    }
  }
  .custom-years-title {
    font-size: 20px !important;
    border-bottom: 2px solid rgba(0, 0, 0, 0.87);
    padding-bottom: 5px;
    margin: 0 42px;
  }
    .buttonToggleContainer {
        display: flex;
        justify-content: space-around;
        overflow-x: auto;
        width: 100%;
    }
.noClosed-months {
  color: #ff0000;
  border-bottom: 2px solid #ff0000;
}

.closed {
  color: #6c9d39;
  border-bottom: 2px solid #6c9d39;
}
.futureMonths {
  color: #000;
}
</style>
